import { FC } from 'react'
import cx from 'classnames'
import Image from '../../../common/Image/Image'
import { IParamPick } from '../../../types'
import css from './ParamPicker.module.scss'
import PercentSvg from '../../../../public/static/icons/icon-percent.svg'

const PickerImage: FC<{
  item: IParamPick
  className?: string
  imageClassName?: string
}> = ({ item, className, imageClassName }) => {
  return (
    <figure className={cx(css.name, className)}>
      <div className={css.imgWrapper}>
        {item?.priceOld !== item?.price && (
          <span className={css.icon}>
            <PercentSvg />
          </span>
        )}
        <div className={cx(css.image_wrapper, imageClassName)}>
          <Image
            src={item?.image}
            objectFit="cover"
            width={38}
            height={38}
            loading="eager"
          />
        </div>
      </div>
      <figcaption>{item?.item}</figcaption>
    </figure>
  )
}

export default PickerImage
